import * as Scrivito from "scrivito"

export const UserKpiWidget = Scrivito.provideWidgetClass("UserKpiWidget", {
  attributes: {
    content: "widgetlist"
  }
})
